module.exports = __webpack_public_path__ + "h5/img/button-bg.a0a81a63.png";